export const zIndex = {
  default: 0,
  absolute: 1,
  drawer: 10,
  textbox: 20,
  popover: 30,
  tooltip: 300,
  header: 600,
  backdrop: 700,
  sidebar: 800,
  dimmar: 900,
  modal: 950,
  modalbox: 1000,
  footer: 500,
};
